export default "__VITE_ASSET__D8e_XhW9__"